import { render, staticRenderFns } from "./LatestVideo.vue?vue&type=template&id=0b7b0a15&"
import script from "./LatestVideo.vue?vue&type=script&lang=js&"
export * from "./LatestVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports